import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { DateUtil, downloadFile, getLongDate } from 'src/app/common/util';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { CashClosureAccountResponse, CashClosureDayResponse, CashClosureDetail, CashClosureTransferResponse, CashTransferDetail, HistoryCashClosureResponse, HistoryClosureResponse } from 'src/app/models/cash-closure.model';
import { SimplePaginationModel } from 'src/app/models/pagination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CashClosureService } from 'src/app/services/cash-closure.service';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';

@Component({
  selector: 'app-history-cash-closure',
  templateUrl: './history-cash-closure.component.html',
  styleUrls: ['./history-cash-closure.component.scss']
})
export class HistoryCashClosureComponent implements OnInit {
  endDate = "";
  startDate = "";
  example: HistoryCashClosureResponse[] = [];
  data: HistoryClosureResponse[] = [];
  accounts: CashClosureAccountResponse[] = [];
  countId = 1;
  showing: { [key: string]: boolean } = {};
  transferSelected = null;
  cashImage = null;
  got = false;
  buttonRollback = new ButtonLoading("btn-danger", false, "ROLLBACK", "fa-rotate-right");
  buttonConfirmDelete = new ButtonLoading("btn-danger", false, "ELIMINAR", "fa-trash");
  cashToDelete = null;
  rollbacking: { [key: number]: boolean } = {};
  payments = { 0: 'EFECTIVO', 1: 'CHEQUE', 2: 'TARJETA', 3: 'TRANSFERENCIA' };
  moreDetails: { [key: number]: boolean } = {};
  paginationAccounts: SimplePaginationModel = new SimplePaginationModel(0, 5, 0, 0, 0);
  sizes = [5, 10, 25, 50, 100];
  notifyOnDelete: boolean = true;

  loadingHistory = false;
  loadingAccounts = false;
  loadingCxcDownload = false;

  get loadingDates(): boolean {
    return this.loadingHistory || this.loadingAccounts;
  }

  private historyRequestId = 0;
  private accountsRequestId = 0;

  constructor(
    private cashClosureService: CashClosureService,
    private toastService: ToastrService,
    private accountingReportService: AccountingReportService
  ) {
    var today = new Date();
    this.endDate = today.toISOString().split("T")[0];
    today.setDate(1);
    this.startDate = today.toISOString().split("T")[0];

  }

  ngOnInit(): void {
    this.refreshTables();
  }

  refreshTables() {
    if (this.loadingDates) {
      return;
    }
    this.getHistory();
    this.getAccounts();
  }

  deleteCashClosure() {
    if (this.buttonConfirmDelete.loading) {
      return;
    }
    this.buttonConfirmDelete.loading = true;
    this.cashClosureService.deleteCashClosure(this.cashToDelete.id, this.notifyOnDelete).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Se eliminó correctamente el cierre de caja!");
        this.buttonConfirmDelete.loading = false;
        this.cashToDelete = null;
        this.showing = {};
        this.refreshTables();
      },
      error: (error: HttpErrorResponse) => {
        this.buttonConfirmDelete.loading = false;
        this.toastService.error("Error al eliminar el cierre");
      }
    })
  }

  // getHistory() {
  //   if (this.startDate && this.endDate) {
  //     this.showing = {};
  //     this.cashClosureService.getHistoryCashClosure(
  //       DateUtil.parseDateToMilliseconds(this.startDate),
  //       DateUtil.parseDateToMilliseconds(this.endDate)).subscribe({
  //         next: (response: ResponseObject) => {
  //           this.got = true;
  //           this.data = response.data;
  //         },
  //         error: (error: HttpErrorResponse) => {
  //           this.got = true;
  //           this.toastService.error("Error al obtener el historial");
  //         }
  //       })
  //   }
  // }

  getHistory() {
    if (!this.startDate || !this.endDate) {
      return;
    }

    const currentRequestId = ++this.historyRequestId;
    this.loadingHistory = true;
    this.got = false;
    this.showing = {};

    this.cashClosureService.getHistoryCashClosure(
      DateUtil.parseDateToMilliseconds(this.startDate),
      DateUtil.parseDateToMilliseconds(this.endDate)
    ).pipe(
      finalize(() => {
        if (currentRequestId === this.historyRequestId) {
          this.loadingHistory = false;
        }
      })
    ).subscribe({
      next: (response: ResponseObject) => {
        if (currentRequestId !== this.historyRequestId) {
          return;
        }
        this.got = true;
        this.data = response.data;
      },
      error: (error: HttpErrorResponse) => {
        if (currentRequestId !== this.historyRequestId) {
          return;
        }
        this.got = true;
        this.toastService.error("Error al obtener el historial");
      }
    });
  }

  // getAccounts() {
  //   if (this.startDate && this.endDate) {
  //     this.cashClosureService.getAccounts(
  //       DateUtil.parseDateToMilliseconds(this.startDate),
  //       DateUtil.parseDateToMilliseconds(this.endDate),
  //       this.paginationAccounts.page,
  //       this.paginationAccounts.size).subscribe({
  //         next: (response: ResponseObject) => {
  //           this.accounts = response.data.list;
  //           this.paginationAccounts.total = response.data.total;
  //           var position = this.paginationAccounts.page * this.paginationAccounts.size;
  //           this.paginationAccounts.start = position + 1;
  //           this.paginationAccounts.end = position + this.accounts.length;
  //           //
  //         },
  //         error: (error: HttpErrorResponse) => {
  //           this.toastService.error('Error al obtener las cuentas');
  //         }
  //       })
  //   }
  // }

  getAccounts() {
    if (!this.startDate || !this.endDate) {
      return;
    }

    const currentRequestId = ++this.accountsRequestId;
    this.loadingAccounts = true;

    this.cashClosureService.getAccounts(
      DateUtil.parseDateToMilliseconds(this.startDate),
      DateUtil.parseDateToMilliseconds(this.endDate),
      this.paginationAccounts.page,
      this.paginationAccounts.size
    ).pipe(
      finalize(() => {
        if (currentRequestId === this.accountsRequestId) {
          this.loadingAccounts = false;
        }
      })
    ).subscribe({
      next: (response: ResponseObject) => {
        if (currentRequestId !== this.accountsRequestId) {
          return;
        }

        this.accounts = response.data.list;
        this.paginationAccounts.total = response.data.total;

        const position = this.paginationAccounts.page * this.paginationAccounts.size;
        this.paginationAccounts.start = position + 1;
        this.paginationAccounts.end = position + this.accounts.length;
      },
      error: (error: HttpErrorResponse) => {
        if (currentRequestId !== this.accountsRequestId) {
          return;
        }
        this.toastService.error('Error al obtener las cuentas');
      }
    });
  }


  rollback(transfer: CashClosureTransferResponse) {
    if (this.buttonRollback.loading || this.rollbacking[transfer.id]) {
      return;
    }
    this.buttonRollback.loading = true;
    this.rollbacking[transfer.id] = true;
    this.cashClosureService.rollbackHistoryCashClosureTransfer(
      transfer.id
    ).subscribe({
      next: (response: ResponseObject) => {
        this.buttonRollback.loading = false;
        this.rollbacking[transfer.id] = false;
        this.toastService.success("Transferencia eliminada correctamente!");
        this.closeModalTransfer();
      },
      error: (error: HttpErrorResponse) => {
        this.buttonRollback.loading = false;
        this.rollbacking[transfer.id] = false;
        this.toastService.error("Error al eliminar la transferencia");
      }
    })
  }

  closeModalTransfer() {
    this.transferSelected = null;
  }

  getImagesDay(day: CashClosureDayResponse) {
    if (!this.showing["d" + day.id] && !day.photos) {
      this.cashClosureService.getImagesByDay(
        day.id
      ).subscribe({
        next: (response: ResponseObject) => {
          day.photos = response.data;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al obtener las imagenes");
        }
      })
    }
    this.showing["d" + day.id] = !this.showing["d" + day.id]
  }

  gettingDetailDays(general: HistoryClosureResponse) {
    if (!this.showing["w" + general.warehouse] && !general.days) {
      this.cashClosureService.getHistoryCashClosureOfWarehouse(
        DateUtil.parseDateToMilliseconds(this.startDate),
        DateUtil.parseDateToMilliseconds(this.endDate),
        general.warehouse).subscribe({
          next: (response: ResponseObject) => {
            general.days = response.data;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error("Error al obtener los días");
          }
        })
    }

    if (!this.showing["w" + general.warehouse] && !general.transfers) {
      this.cashClosureService.getHistoryCashClosureTransfers(
        DateUtil.parseDateToMilliseconds(this.startDate),
        DateUtil.parseDateToMilliseconds(this.endDate),
        general.warehouse).subscribe({
          next: (response: ResponseObject) => {
            general.transfers = response.data;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error("Error al obtener las transferencias");
          }
        })
    }
    this.showing["w" + general.warehouse] = !this.showing["w" + general.warehouse];
  }


  deleteCashClosureAccount(account: any) {
    console.log(account.id);
    this.cashClosureService.deleteAccountReceivable(account.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Se eliminó correctamente la cuenta por cobrar");
        this.refreshTables();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al eliminar la cuenta por cobrar");
      }
    })
  }

  getCashClosuresAccountReport(type: string) {
    if (!this.startDate || !this.endDate) {
      this.toastService.error("Debe seleccionar fecha inicial y final.");
      return;
    }
    this.loadingCxcDownload = true;
    //var companyId = this.selected ? this.selected.companyId : null;
    // si es null traer todas las companies
    this.accountingReportService.getCashClosuresAccountReport(type, getLongDate(this.startDate), getLongDate(this.endDate)).subscribe({
      next: (response: ResponseObject) => {
        if (type == 'json') {
          // logica para mostrar
        } else {
          downloadFile(response.data, type, 'Cierre de caja Cuentas por Cobrar ');
          this.toastService.success("Se ha descargado correctamente el Cierre de caja Cuentas por Cobrar");
        }
        this.loadingCxcDownload = false;
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener el Cierre de caja Cuentas por Cobrar");
        this.loadingCxcDownload = false;
      }
    })
  }
}
